import React, { useState, useEffect } from 'react';
import { HiOutlineCollection } from 'react-icons/hi';
import CategoryCard from '../components/CategoryCard';
import SearchBar from '../components/SearchBar';

function Library({ categories, onCategorySelect }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredCategories, setFilteredCategories] = useState([]);
  
  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredCategories(categories);
    } else {
      const filtered = categories.filter(category =>
        category.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredCategories(filtered);
    }
  }, [searchTerm, categories]);
  
  const totalStickers = categories.reduce((sum, cat) => sum + (cat.sticker_count || 0), 0);
  
  return (
    <div className="library-page">
      {/* Header */}
      <div className="page-header">
        <h1 className="page-title">Sua biblioteca de stickers</h1>
        <p className="page-subtitle">
          Explore por categoria, salve seus favoritos e baixe em PNG.
        </p>
      </div>
      
      {/* Stats */}
      <div className="stats-section">
        <div className="stat-card">
          <div className="stat-value">{categories.length}</div>
          <div className="stat-label">Categorias</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{totalStickers}</div>
          <div className="stat-label">Stickers</div>
        </div>
      </div>
      
      {/* Search */}
      <SearchBar 
        value={searchTerm}
        onChange={setSearchTerm}
        placeholder="Buscar em todas as categorias..."
      />
      
      {/* Section Title */}
      <h2 style={{ 
        fontFamily: "'Playfair Display', serif",
        fontSize: '1.5rem',
        marginBottom: '24px',
        color: 'var(--color-text-primary)'
      }}>
        Categorias
      </h2>
      
      {/* Categories Grid */}
      {filteredCategories.length > 0 ? (
        <div className="categories-grid">
          {filteredCategories.map((category) => (
            <CategoryCard 
              key={category.id} 
              category={category}
              onSelect={onCategorySelect}
            />
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <div className="empty-state-icon">
            <HiOutlineCollection />
          </div>
          <h3 className="empty-state-title">Nenhuma categoria encontrada</h3>
          <p className="empty-state-text">
            Tente buscar com outros termos ou explore todas as categorias disponíveis.
          </p>
        </div>
      )}
    </div>
  );
}

export default Library;
